import { registerAndSendPageViewEvent } from '@invideoio/web-shared/utils/analytics/Register';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { PageType } from '@invideoio/web-shared/types/Analytics';
import { AnalyticsUtils } from '@invideoio/web-shared/utils/analytics/AnalyticsUtils';
import { Referrer } from '@invideoio/web-shared/utils/utils.constant';
import {
  sendAmplitudeAnalyticEvent,
  AmplitudeEvents,
  sendRudderStackAnalyticEvent,
} from '@utils/analytics';
import { useEffect } from 'react';

interface useBlogAppLoadOptions {
  platform?: PlatformType;
}

function useBlogAppLoad(options?: useBlogAppLoadOptions) {
  useEffect(() => {
    AnalyticsUtils.setReferrer(Referrer.WEBSITE);

    registerAndSendPageViewEvent(PageType.BLOG, {
      location: window.location.href,
    });

    sendAmplitudeAnalyticEvent(AmplitudeEvents.appLoad);
  }, []);
}

export default useBlogAppLoad;
